/* eslint-disable react/jsx-key */
import React from 'react'
import R from 'ramda'
import { connect } from 'react-redux'
import { Button, Input, Form, Select, Alert, Modal, message } from 'antd'

import { loadDataForDate } from 'core/actions'
import { CriteriaRow, Title, Content } from 'core/screen-util'
import {
  globalUnitReAssignmentInfo,
  getUnitNameMap as getNewUnitNameMap,
} from 'api/pgads'
import { getUtilityUnitsMap } from 'core/selectors'
import { getApiTargetInfo, getUnitNameMap, getUtilityNameMap } from 'core'
import { SpinContext, ErrorContext, DatePickerContext } from 'context'
import * as ACT from 'core/action-names'

const { Option } = Select
const { confirm } = Modal

const utilityOption = R.compose(
  R.map(([key, text]) => (
    <Option key={key} value={key}>{`${key} - ${text}`}</Option>
  )),
  R.sortBy(([, text]) => text.toLowerCase()),
  R.toPairs
)

class GlobalUnitReAssignment extends React.Component {
  state = {
    data: [],
    newUnit: '',
    newUnitMap: [],
  }

  setErr = err => this.setState({ loading: false, err })

  setMsg = msg => message.info(msg)

  doConfirm = _ => {
    const { oldUtility, oldUnit, newUtility, newUnit } = this.state

    oldUtility == null || newUtility == null
      ? message.error(
          'Please select a current utility and a new utility to update'
        )
      : oldUnit == null
      ? message.error('Please select a current unit to update')
      : newUnit === ''
      ? message.error('Please enter a new unit code to update')
      : newUnit.length > 3
      ? message.error(
          'The new Unit Code must be three alphanumeric characters or less'
        )
      : this.confirmExecute()
  }

  doExecute = () => {
    const { apiTargetInfo, setSpinning, setError } = this.props
    const { oldUtility, oldUnit, newUtility, newUnit } = this.state
    setSpinning(true)
    globalUnitReAssignmentInfo(apiTargetInfo)(
      oldUtility,
      oldUnit,
      newUtility,
      newUnit
    ).fork(setError, _ => {
      this.setState({
        loading: false,
        newUnit: '',
        oldUtility: undefined,
        oldUnit: undefined,
        newUtility: undefined,
      })
      setSpinning(false)
      message.success('Assignment Successful', 20)
      this.reloadData()
    })
  }

  confirmExecute = () =>
    confirm({
      width: '50vw',
      title: 'Confirm',
      content:
        'Are you sure you want to re-assign all the data for this utility/unit?',
      onOk: () => {
        this.doExecute()
      },
      onCancel() {},
    })

  reloadData = () => {
    const {
      apiTargetInfo,
      loadData,
      selectedDate,
      saveUnitNameMap,
      setError,
    } = this.props
    // getUtilityUnitMap(apiTargetInfo).fork(this.setErr, utilityUnitMap =>
    //   this.setState(_ => ({ utilityUnitMap }))
    // )
    loadData(selectedDate) // .fork(_ => _, this.setState(_ => ({ loading: false })))
    getNewUnitNameMap(apiTargetInfo).fork(setError, data =>
      saveUnitNameMap(data)
    )
  }

  createUnitMap = value => {
    const unitList = this.props.utilityUnitMap[value]
    const unitMap = unitList
      ? unitList.map(u => ({
          key: u,
          value: u,
          text: `${u.substring(value.length)} - ${this.props.unitNameMap[u]}`,
        }))
      : []
    this.setState({ newUnitMap: unitMap })
  }

  render() {
    const {
      loading = false,
      oldUtility,
      oldUnit,
      newUtility,
      newUnit,
      newUnitMap,
    } = this.state
    const { utilityNameMap } = this.props

    const formItemLayout = { labelCol: { span: 5 }, wrapperCol: { span: 15 } }
    const formTailLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 8, offset: 4 },
    }

    return [
      <CriteriaRow>
        <Title>Global Unit Re-Assignment</Title>
      </CriteriaRow>,
      <Content>
        <Form.Item {...formItemLayout} label="Current Utility ">
          <Select
            placeholder="Select a Utility"
            style={{ width: '350px' }}
            value={oldUtility}
            onChange={value =>
              this.setState(
                _ => ({
                  oldUtility: value,
                  oldUnit: oldUtility === value ? oldUnit : undefined,
                }),
                this.createUnitMap(value)
              )
            }
          >
            {utilityOption(utilityNameMap)}
          </Select>
        </Form.Item>
        <Form.Item {...formItemLayout} label="Current Unit ">
          <Select
            placeholder="Select a Unit"
            style={{ width: '350px' }}
            onChange={value => this.setState({ oldUnit: value })}
            value={oldUnit}
          >
            {newUnitMap
              .sort((u, v) => (u.text <= v.text ? -1 : 1))
              .map(unit => (
                <Option key={unit.key} value={unit.value}>
                  {unit.text}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item {...formItemLayout} label="New Utility ">
          <Select
            placeholder="Select a Utility"
            style={{ width: '350px' }}
            value={newUtility}
            onChange={value => this.setState({ newUtility: value })}
          >
            {utilityOption(utilityNameMap)}
          </Select>
        </Form.Item>
        <Form.Item {...formItemLayout} label="New Unit Code ">
          <Input
            style={{ width: '350px' }}
            placeholder="Enter Unit Code"
            value={newUnit}
            onChange={e => this.setState({ newUnit: e.target.value })}
          />
        </Form.Item>
        <Form.Item {...formTailLayout}>
          <Button type="primary" loading={loading} onClick={this.doConfirm}>
            Execute
          </Button>
        </Form.Item>
        <Alert
          message={<b>Note:</b>}
          description={
            <p>
              Use this function to reassign identification code for a single
              generation asset.
              <br />
              This operation updates all historical event, fuel and performance
              data using the new Utility and Unit code.
            </p>
          }
          type="info"
        />
      </Content>,
    ]
  }
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
})

const mapDispatchToProps = dispatch => ({
  loadData: selectedDate => dispatch(loadDataForDate(selectedDate)),
  saveUnitNameMap: nameMap =>
    dispatch({ payload: nameMap, type: ACT.STORE_UNIT_NAME_MAP }),
})

const GlobalUnitReAssignmentWrap = props => (
  <SpinContext.Consumer>
    {({ spinning, setSpinning }) => (
      <DatePickerContext.Consumer>
        {({ selectedDate }) => (
          <ErrorContext.Consumer>
            {({ setError }) => (
              <GlobalUnitReAssignment
                selectedDate={selectedDate}
                setError={setError}
                setSpinning={setSpinning}
                spinning={spinning}
                {...props}
              />
            )}
          </ErrorContext.Consumer>
        )}
      </DatePickerContext.Consumer>
    )}
  </SpinContext.Consumer>
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalUnitReAssignmentWrap)
